import React, { useCallback, useRef } from "react";

const ROW_CLASS = "is-crosshair-row";
const COLUMN_CLASS = "is-crosshair-col";

// Highlights the hovered cell's hour label and stage header in a heatmap table. Classes are toggled directly on the cells so the table does not
// re-render on every mouse move.
export const useGridCrosshair = () => {
  const activeCellsRef = useRef<Element[]>([]);

  const clear = useCallback(() => {
    activeCellsRef.current.forEach((cell) =>
      cell.classList.remove(ROW_CLASS, COLUMN_CLASS),
    );
    activeCellsRef.current = [];
  }, []);

  const onMouseOver = useCallback(
    (event: React.MouseEvent<HTMLTableElement>) => {
      const cell = (event.target as HTMLElement).closest("td");
      const row = cell?.parentElement as HTMLTableRowElement | null;
      const table = event.currentTarget;
      if (!cell || !row || !table.tBodies[0]?.contains(row)) {
        return;
      }
      clear();
      const columnIndex = (cell as HTMLTableCellElement).cellIndex;
      const active: Element[] = [];
      // Only the row's hour label and the column's stage header, not the other data cells.
      const hourCell = row.cells[0];
      if (hourCell?.tagName === "TH") {
        hourCell.classList.add(ROW_CLASS);
        active.push(hourCell);
      }
      const headerCell = table.tHead?.rows[0]?.cells[columnIndex];
      if (headerCell) {
        headerCell.classList.add(COLUMN_CLASS);
        active.push(headerCell);
      }
      activeCellsRef.current = active;
    },
    [clear],
  );

  return { onMouseOver, onMouseLeave: clear };
};
